import {
  CancelDeliveryReasonsService,
  type PostPutCancelDeliveryReasonTranslationAdmin
} from '@/backend/market'
import { CancelDeliveryReasonRepository } from '../../domain/repositories/CancelDeliveryReasonRepository'
import { CancelDeliveryReasonModel } from '../models/CancelDeliveryReasonModel'
import { CancelDeliveryReasonMiniModel } from '../models/CancelDeliveryReasonMiniModel'
import type { CancelDeliveryReasonMiniEntity } from '../../domain/entities/CancelDeliveryReasonMiniEntity'
import type { CancelDeliveryReasonEntity } from '../../domain/entities/CancelDeliveryReasonEntity'

export class CancelDeliveryReasonRepositoryImpl implements CancelDeliveryReasonRepository {
  async getCancelDeliveryReasons(): Promise<CancelDeliveryReasonMiniEntity[] | { error: true }> {
    try {
      const response = await CancelDeliveryReasonsService.getCancelDeliveryReasonsAdmin({})
      const cancelDeliveryReasonModels = response.map(
        (reason) => new CancelDeliveryReasonMiniModel(reason)
      )

      return cancelDeliveryReasonModels
    } catch {
      return { error: true }
    }
  }
  async getCancelDeliveryReasonById(
    id: number
  ): Promise<CancelDeliveryReasonEntity | { error: true }> {
    try {
      const response = await CancelDeliveryReasonsService.getCancelDeliveryReasonByIdAdmin({
        id
      })
      const cancelDeliveryReasonModel = new CancelDeliveryReasonModel(response)

      return cancelDeliveryReasonModel
    } catch {
      return { error: true }
    }
  }
  async createCancelDeliveryReason(
    data: CancelDeliveryReasonEntity
  ): Promise<{ success: true } | { error: true }> {
    try {
      await CancelDeliveryReasonsService.postCancelDeliveryReasonAdmin({
        requestBody: {
          translations: data.translations?.map((translation) => ({
            language: translation.language,
            text: translation.text
          })) as PostPutCancelDeliveryReasonTranslationAdmin[]
        }
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async updateCancelDeliveryReason(
    id: number,
    data: CancelDeliveryReasonEntity
  ): Promise<{ success: true } | { error: true }> {
    try {
      await CancelDeliveryReasonsService.putCancelDeliveryReasonAdmin({
        id,
        requestBody: {
          translations: data.translations?.map((translation) => ({
            language: translation.language,
            text: translation.text
          })) as PostPutCancelDeliveryReasonTranslationAdmin[]
        }
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async deleteCancelDeliveryReason(id: number): Promise<{ success: true } | { error: true }> {
    try {
      await CancelDeliveryReasonsService.deleteCancelDeliveryReasonAdmin({
        id
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
